import { purry } from './purry';
export function omit() {
    return purry(_omit, arguments);
}
function _omit(object, names) {
    var set = new Set(names);
    return Object.entries(object).reduce(function (acc, _a) {
        var name = _a[0], value = _a[1];
        if (!set.has(name)) {
            acc[name] = value;
        }
        return acc;
    }, {});
}
